import { en } from "./locales/en"
import { fr } from "./locales/fr"

export const SUPPORTED_LOCALES = ['fr', 'en']
export const DEFAULT_LOCALE = 'fr'

export const translations = {
  fr: {...fr},
  en: {...en}
}
